import { useEffect, useState } from "react";
import { axios } from "../api/axios";
import { useLocation, useNavigate } from "react-router-dom";
import { ViewLayout } from "../features/films/sections/view.layout";
import { ViewFilm } from "../features/films/pages/view.page";
import { ViewSeries } from "../features/series/pages/view.page";
import { ViewBusinessProfile } from "../features/business-profile/pages/view.page";
import { ViewProfessionalProfile } from "../features/professional-profile/pages/view.page";
import { CreateFilm } from "../features/films/pages/create.page";
import { CreateSeries } from "../features/series/pages/create.page";

export const NotFoundPage = ({ isEditing }: { isEditing?: boolean }) => {
  const navigate = useNavigate();

  const [loaded, setLoaded] = useState(false);
  const [category, setCategory] = useState<
    "film" | "series" | "business_profile" | "professional_profile"
  >("film");

  const location = useLocation();
  const paths = location.pathname.split("/").filter((el) => !!el);
  console.log(paths);

  useEffect(() => {
    if (paths.length > 1 && !paths.includes("edit")) {
      setLoaded(true);
    } else {
      axios
        .get<{
          type: "film" | "series" | "business_profile" | "professional_profile";
        }>(`/client/custom-url/detail?custom_name=${paths[0]}`)
        .then((resp) => {
          setCategory(resp.data.type);

          setLoaded(true);
          // navigate(`/${redirectPath}/${paths[0]}`);
        })
        .catch(() => {
          setLoaded(true);
        });
    }
  }, [paths]);

  return (
    <>
      {loaded ? (
        category === "film" ? (
          isEditing ? (
            <CreateFilm editing />
          ) : (
            <ViewFilm />
          )
        ) : category === "series" ? (
          isEditing ? (
            <CreateSeries editing />
          ) : (
            <ViewSeries />
          )
        ) : category === "business_profile" ? (
          <ViewBusinessProfile />
        ) : (
          <ViewProfessionalProfile />
        )
      ) : (
        <ViewLayout id="" customUrl={paths[0]} title="" loading viewOnly>
          <></>
        </ViewLayout>
      )}
    </>
  );
};
